export var ConditionRelations;
(function (ConditionRelations) {
    ConditionRelations["AND"] = "AND";
    ConditionRelations["OR"] = "OR";
})(ConditionRelations || (ConditionRelations = {}));
